import { render, staticRenderFns } from "./scratchCheck.vue?vue&type=template&id=7a3a3c14&scoped=true&"
import script from "./scratchCheck.vue?vue&type=script&lang=js&"
export * from "./scratchCheck.vue?vue&type=script&lang=js&"
import style0 from "./scratchCheck.vue?vue&type=style&index=0&id=7a3a3c14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a3c14",
  null
  
)

export default component.exports